import SettingsIcon from "@/assets/settings.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const SettingsLogo = (props: Props) => (
  <LogoImage imgSrc={SettingsIcon} alt="Settings Logo" size="navbar" {...props} />
);
